<style lang="stylus">
    .aiCreate
        display flex
        justify-content center
        align-items center
        position fixed
        left 0
        top 0
        width 100%
        height 100%
        user-select none
        z-index 101
        .aiCreate-mask
            modal-mask()
        .aiCreate-text
            color #fff
            font-size 26px
            font-weight 700
            z-index 1000
</style>

<template>
    <div class="aiCreate">
        <div class="aiCreate-mask"></div>
        <p class="aiCreate-text">{{ $t("creating") }}</p>
    </div>
</template>

<script lang="ts">
    import { Watch, Component, Prop, Vue } from "vue-property-decorator";
    import AiSocket from "@/app/mixin/aiSocket";
    import { parseMermaidText } from "@/public/utils/tool.js";

    @Component({
        components: {},
    })
    export default class Base extends AiSocket {
        @Prop()
        aiType;
        @Prop()
        aiKeys;
        inputText = "";

        goGenerating() {
            if (!["flow", "mindmap", "list", "form"].includes(this.aiType)) {
                // 类型错误
                return;
            }
            if (!this.aiKeys) {
                // 关键字错误
                return;
            }
            this.inputText = this.aiKeys;

            let typeMap = {
                text: ["continue", "Q&A"],
                flow: ["flowchart", "Flow Chart"],
                mindmap: ["mindmap-md", "Mind Mapping"],
                list: ["chat", "List"],
                form: ["form", "Sheet"],
            };
            let values = typeMap[this.aiType],
                type = values[0];
            this.generating(type)
                .then(() => {
                    let _view = window["_view"],
                        page = _view._activePage;
                    // 文本续写
                    if (this.aiType == "text") {
                        let textList = this.resultText.split("\n");
                        textList.unshift(this.inputText);
                        _view.generateTextTemplate(page, textList);
                    }
                    // 生成流程图
                    if (this.aiType == "flow") {
                        // const parserObj = parseMermaidText(this.resultText);
                        // _view.generateFlowFromMermaid(page, parserObj);
                        _view.generateFlow(page, this.resultText);
                    }
                    // 生成多级思维导图
                    if (this.aiType == "mindmap") {
                        _view.generateMindMap(page, this.inputText, this.resultText);
                    }
                    // 生成列表
                    if (this.aiType == "list") {
                        let textList = this.resultText.split("\n");
                        textList.unshift(this.inputText);
                        _view.generateListTemplate(page, textList);
                    }
                    // 生成表格
                    if (this.aiType == "form") {
                        _view.generateForm(page, this.resultText);
                    }
                })
                .finally(() => {
                    this.$emit("aiCreateDone");
                });
        }

        created() {
            this.initAiSocket().then(() => {
                this.goGenerating();
            });
        }
        mounted() {}
        beforeDestroy() {}
    }
</script>
<i18n>
{
    "zh": {
        "creating": "AI生成中..."
    },
    "en": {
        "creating": "Executing your command.."
    }
}
</i18n>
